import api from '../../utils/axios.js';

const cabinetByID = async (cabinetId, populate = false) => {
	const { data } = await api.get(
		`/cabinets?search[id]=${cabinetId}${populate ? '&populate=true' : ''}`
	);

	return data;
};

const cabinetService = {
	cabinetByID,
};

export default cabinetService;
